import { AppRoutes } from '@constants/app-routes'
import { Link } from '@ui/links/Link'

const baseUrl = '/images/cases/platform-for-improving-diagnostic-accuracy'

export const overview = {
  sections: [
    {
      id: 1,
      title: 'Business vertical',
      image: {
        src: `${baseUrl}/business-vertical.webp`,
        alt: 'Business vertical',
        title: 'Business vertical',
        width: 50,
        height: 50,
      },
    },
    {
      id: 2,
      text: <Link href={AppRoutes.medtech}>MedTech</Link>,
    },
    {
      id: 3,
      title: 'Initial project team size',
      image: {
        src: `${baseUrl}/project-team-size.webp`,
        alt: 'Project team size',
        title: 'Project team size',
        width: 50,
        height: 50,
      },
    },
    {
      id: 4,
      text: '6 specialists',
    },
    {
      id: 5,
      title: 'Cooperation period',
      image: {
        src: `${baseUrl}/cooperation-period.webp`,
        alt: 'Cooperation period',
        title: 'Cooperation period',
        width: 50,
        height: 50,
      },
    },
    {
      id: 6,
      text: 'Ongoing since May 2022 ',
    },
    {
      id: 7,
      title: 'Modsen augmentation team',
      image: {
        src: `${baseUrl}/team-augmentation.webp`,
        alt: 'Team augmentation',
        title: 'Team augmentation',
        width: 50,
        height: 50,
      },
    },
    {
      id: 8,
      text: '4+1 developer engineers, 2 QA testers',
    },
  ],
}

export const sectionsMobile = [
  {
    id: 1,
    title: 'Business vertical',
    text: <Link href={AppRoutes.medtech}>MedTech</Link>,
    image: {
      src: `${baseUrl}/business-vertical.webp`,
      alt: 'Business vertical',
      title: 'Business vertical',
      width: 50,
      height: 50,
    },
  },
  {
    id: 3,
    title: 'Initial project team size',
    text: '6 specialists',
    image: {
      src: `${baseUrl}/project-team-size.webp`,
      alt: 'Project team size',
      title: 'Project team size',
      width: 50,
      height: 50,
    },
  },
  {
    id: 5,
    title: 'Cooperation period',
    text: 'Ongoing since May 2022 ',
    image: {
      src: `${baseUrl}/cooperation-period.webp`,
      alt: 'Cooperation period',
      title: 'Cooperation period',
      width: 50,
      height: 50,
    },
  },
  {
    id: 7,
    title: 'Modsen augmentation team',
    text: '4+1 developer engineers, 2 QA testers',
    image: {
      src: `${baseUrl}/team-augmentation.webp`,
      alt: 'Team augmentation',
      title: 'Team augmentation',
      width: 50,
      height: 50,
    },
  },
]
